import type { TFunction } from 'i18next'
import { logger } from '@utils/logger'
import { NAV_ITEM_BY_ID } from '../../constants/appSuites'
import type { NavItem, NavSection } from '../../constants/navigation'
import type { LauncherApp, NavItemId } from '../../types/appSuites'

/** Sidebar sections for one app. Unknown item ids are skipped, not thrown. */
export function appSectionsFor(
  app: LauncherApp,
  source: 'default' | 'custom',
  t: TFunction,
): NavSection[] {
  return app.sections.map((section) => {
    const items: NavItem[] = []
    for (const itemId of section.item_ids) {
      const item = NAV_ITEM_BY_ID[itemId as NavItemId]
      if (!item) {
        logger.warn('app_suites: skipping unknown nav item', { itemId, appId: app.id })
        continue
      }
      items.push(item)
    }
    const defaultKey = `appSuites.default.${app.id}.sections.${section.id}`
    const rawLabel =
      source === 'default' ? (t(defaultKey, { defaultValue: section.label }) as string) : section.label
    const labelOverride = rawLabel.trim() ? rawLabel : undefined
    return {
      id: `${app.id}-${section.id}`,
      labelOverride,
      items,
    }
  })
}
